import React from 'react';
import { FormikProps } from 'formik';
import { RelationshipsProps } from '../../models/account-info-epi-props';
import { DividerSection } from '../../../../global/components/layout/divider-section';
import { MaritalStatusFormValues } from './marital-form-models';
import { LabelSettingProps } from '../../../../global/models/epi-model';
import { FormField } from '../../../../global/components/form-element/form-field';
import { LabelAndValue } from '../../../../global/components/data-display/label-value';
import { MaritalStatusOptions } from '../../../../global/constants/lists';
import { PersonFieldsDisplay } from '../../components/read-only/person-fields-display';
import { MailingAddressDisplay } from '../../components/read-only/mailing-address-display';
import { PhonesDisplay } from '../../components/read-only/phones-display';
import { EmailsDisplay } from '../../components/read-only/emails-display';

interface Props {
    labelSetting: LabelSettingProps;
    relationshipsProps: RelationshipsProps;
    formProps: FormikProps<MaritalStatusFormValues>;
    personSelected: boolean;
}
export function MaritalStatusConfirmation(props: Props) {

    const { labelSetting, formProps, relationshipsProps, personSelected } = props;
    const { values } = formProps;

    return (
        <>
            <LabelAndValue label={labelSetting.maritalStatusLabel} value={MaritalStatusOptions.married.label} />
            <PersonFieldsDisplay
                labelSetting={labelSetting}
                values={values}
                sectionText={relationshipsProps.spouseInformationSectionLabel}
                dobMasked={personSelected}
            />
            <MailingAddressDisplay
                labelSetting={labelSetting}
                values={values}
            />

            <PhonesDisplay
                labelSetting={labelSetting}
                values={values}
            />

            <EmailsDisplay
                labelSetting={labelSetting}
                values={values}
            />

            <DividerSection removeDivider>
                <FormField
                    name='marital_status_effective_date'
                    label={relationshipsProps.dateOfMarriageLabel}
                    component='datePicker'
                    touched={formProps.touched}
                    errors={formProps.errors}
                    required
                    autoWidth
                    tooltip={{ title: relationshipsProps.dateOfMarriageTooltip }}
                />
            </DividerSection>

        </>
    );
}